<template>
  <section v-if="purchaseOrderItems.length">
    <table class="table table-sm table-bordered">
      <thead class="thead-light">
        <tr>
          <th class="w-min no-br">{{ "index" | translate }}</th>
          <th class="no-br">{{ "vendor" | translate }}</th>
          <th class="no-br">{{ "order_num" | translate }}</th>
          <th class="no-br">{{ "quantity" | translate }}</th>
          <th class="no-br">{{ "amount" | translate }}</th>
          <th class="no-br">{{ "payments" | translate }}</th>
          <th class="no-br">{{ "comment" | translate }}</th>
          <th class="no-br" v-no-print v-if="!readonly">@</th>
        </tr>
      </thead>

      <tbody>
        <tr :key="'item' + index" v-for="(item, index) in purchaseOrderItems">
          <td>{{ index + 1 }}</td>
          <td class="w-10">{{ item.vendor }}</td>
          <td class="w-15">{{ item.orderNumber }}</td>
          <td class="w-5">{{ item.quantity }}</td>
          <td class="w-10 no-br">
            {{ item.amount | number(2) }} {{ item.currency | translate }}
          </td>
          <td>
            <part-transaction-list-present
              :transactions="item.payments"
            ></part-transaction-list-present>
          </td>
          <td class="w-15">{{ item.comment }}</td>
          <td class="w-min no-br" v-no-print v-if="!readonly">
            <a
              class="mr-1"
              href="javascript:void(0)"
              @click="editPurchaseOrderItem(item)"
              >{{ "edit" | translate }}</a
            >
            <a href="javascript:void(0)" @click="remove(index)">{{
              "remove" | translate
            }}</a>
          </td>
        </tr>
      </tbody>

      <tfoot>
        <tr>
          <th colspan="3">{{ "total" | translate }}</th>
          <th>{{ totalQuantity }}</th>
          <th colspan="3" class="text-right">
            <div v-for="(total, index) in totalAmount" :key="'t' + index">
              {{ total.total | number(2) }} {{ total.currency | translate }}
            </div>
          </th>
          <th v-no-print v-if="!readonly"></th>
        </tr>
      </tfoot>
    </table>
  </section>
</template>

<script>
import { ModalService } from "@/modules/xs-modal";
import ModalPurchaseOrderItemForm from "./ModalPurchaseOrderItemForm";
import PartTransactionListPresent from "./PartTransactionListPresent";
import _ from "lodash";

export default {
  props: ["purchaseOrderItems", "readonly"],
  data() {
    return {};
  },
  computed: {
    totalQuantity() {
      return this.purchaseOrderItems.reduce((sum, item) => {
        if (item.quantity) {
          return sum + item.quantity;
        }
        return sum;
      }, 0);
    },
    totalAmount() {
      let currencyList = [
        ...new Set(this.purchaseOrderItems.map(item => item.currency))
      ];

      return currencyList.map(curr => {
        return {
          currency: curr,
          total: this.purchaseOrderItems.reduce((sum, item) => {
            if (item.quantity && item.currency === curr) {
              return sum + item.amount;
            }
            return sum;
          }, 0)
        };
      });
    }
  },
  methods: {
    editPurchaseOrderItem(item) {
      ModalService.open(ModalPurchaseOrderItemForm, {
        editingItem: item
      }).then(purchaseOrderItem => {
        _.assign(item, purchaseOrderItem);
        this.$emit("update");
      });
    },
    remove(index) {
      this.purchaseOrderItems.splice(index, 1);
      this.$emit("update");
    }
  },
  components: {
    PartTransactionListPresent
  }
};
</script>
